export enum ProductTextureGenerationStatus {
    ready = 'ready',
    verification = 'verification',
    dirty = 'dirty',
    error = 'error',
    inProgress = 'in_progress',
}
